"use client";

import { Slot } from "@radix-ui/react-slot";
import { Loader2 } from "lucide-react";
import { useTransition } from "react";
import { twMerge } from "tailwind-merge";

import { cn } from "~/lib/utils";

import type { ButtonProps } from "./button";
import { buttonVariants } from "./button";

function Button({
	ref: reference,
	className,
	variant,
	size,
	disabled = false,
	pending = false,
	asChild = false,
	type = "button",
	onClick,
	children,
	...props
}: { ref?: React.Ref<HTMLButtonElement> } & ButtonProps) {
	const [_pending, startTransition] = useTransition();
	if (_pending) pending = true;

	const Component = asChild ? Slot : "button";
	children ??= "Continue";

	return (
		<Component
			className={cn(buttonVariants({ variant, size, className }))}
			disabled={disabled || pending}
			ref={reference}
			type={type}
			onClick={type !== "submit"
				? (event) => startTransition(() => onClick?.(event))
				: onClick}
			{...props}
		>
			{pending
				? (
						<>
							<Loader2 className="absolute size-4 animate-spin" />
							<span className={twMerge("pointer-events-none opacity-0", className)}>
								{children}
							</span>
						</>
					)
				: children}
		</Component>
	);
}
Button.displayName = "Button";

export { Button };
